import { ProcessDeUtil } from '../../../../domain/process-de-util';
export class ComponentEntity {
    Id: string;
    Name: string;
    MetadataId: string;
    ComponentType: string;
    MethodCode: string;
    Execution: string;
    AsyncCallBackType: string;
    Time: string;
    isForCompensation: boolean;
    ActualParameters: Array<ActualParameter>;
    constructor() {
        this.Id = ProcessDeUtil.GenerateElementId();
        this.ActualParameters = new Array();
    }
}
export class ActualParameter {
    Name: string;
    Value: string;
    ValueText?: string;
    Tag?: string;
    fetchValueMode?: any;
    fetchValueSetting?: any;
}
